'use strict';
angular.module('amexReconciliationApp')
  .component('receiptBillingCycleInput', {
    bindings: {
      onBillingCycleChange: '&'
    },
    templateUrl: 'scripts/views/components/receipt-billing-cycle-input.html',
    controller: function (TransactionSearchModel,
                          BillingCycleModel,
                          $filter,
                          $translate) {
      var self = this;
      self.billingCycles = [];
      self.currentBillingCycle = '';

      self.$onInit = function () {
        setBillingCycles();
        self.onBillingCycleChange({billingCycle: self.currentBillingCycle});
      };

      function setBillingCycles() {
        var formattedBillingCycles = [getAllCycleMessage()];
        var cycles = BillingCycleModel.billingCycles();
        for (var i = 0; i < cycles.length; i++) {
          var cycle = cycles[i];
          var formattedCycle = formatBillingCycle(cycle);

          formattedBillingCycles.push(
            {
              'formattedCycle': formattedCycle,
              'endDate': cycle.endDate
            }
          );
        }

        self.billingCycles = formattedBillingCycles;
        self.currentBillingCycle = _.find(formattedBillingCycles, {'endDate': TransactionSearchModel.billingCycle().endDate});
      }

      function formatBillingCycle(cycle) {
        return $filter('userPreferenceDateFormat')(cycle.startDate) + ' - ' + $filter('userPreferenceDateFormat')(cycle.endDate);
      }

      function getAllCycleMessage() {
        return {'formattedCycle': $translate.instant('receipt.titles.AllCycles'), 'endDate': false};
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/receiptBillingCycleInput.js
// module id = 471
// module chunks = 0